import React from "react";
import styles from "./pifflePlaque.module.css";

export default function PifflePlaque({
  name,
  media,
  birthYear,
  title,
  creationYear,
  description,
}) {
  return (
    <div className={styles.pifflePlaque}>
      <h2>{title}</h2>
      <h2 className={styles.artistName}>
        {name} (b.{birthYear})
      </h2>
      <p>{description}</p>
      <h3 className={styles.info}>
        {media}, {creationYear}
      </h3>
    </div>
  );
}
